import { render, staticRenderFns } from "./ModalCartTimer.vue?vue&type=template&id=2e972f98"
import script from "./ModalCartTimer.vue?vue&type=script&lang=js"
export * from "./ModalCartTimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports